
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
    Consultant (Question Bank-AI)
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">



         

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Qualification: </h3>
              <p><span class="step_no">1</span> Essential: Bachelor of Engineering in any branch </p>
                <p><span class="step_no">2</span>Desirable- Post graduate in Engineering & completed any courses related to AI prompt Engineering</p>

            </div>
          </div>
        </div>
        <!-- feature box close -->


<!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Experience: </h3>
              <p> 1-3 Years of experience in generating AI prompts and preferably in question bank preparation  </p>

            </div>
          </div>
        </div>
        <!-- feature box close -->


<!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Job Description Overview: </h3>
              <p>We are seeking a highly skilled Generalist AI Prompt Engineer to join our team for the development of a comprehensive question bank.
                The ideal candidate will have a strong background in AI, prompt engineering, and educational content creation, with a focus on vocational and technical education.

              </p>
            </div>
          </div>
        </div>
        <!-- feature box close -->


  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p>Rs. 40,000/- to Rs. 50,000/- per month(based on Relevant experience and expertise) </p>

      </div>
    </div>
  </div>
  <!-- feature box close --> 
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 11th July 2024 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->
<!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Key Responsibility:</h3>
		
        <p> <span class="step_no">1</span><b>Prompt Engineering :</b><br> 
            Design, develop,and refine AI prompts to generate high-quality multiple-choice questions(MCQs) aligned with educational standards and guidelines.
        Ensure questions are uniquely crafted for each topic,avoiding repetition and maintaining high quality. </p>
        <p> <span class="step_no">2</span><b>Content Development </b><br> 
            Create MCQs for ITI level vocational education curriculum based on Bloom's taxonomy and other educational frameworks.</p>
            Generate questions that cover all syllabus content and align with detailed guidelines on levels (<b>Remember, understand and Apply</b>), question types, format, options, content,and quality standards.<br>
            Translate questions and options from English to required languages,ensuring accuracy and consistency, particularly for technical terms.<br>
            <p> <span class="step_no">3</span><b>Collaboration and Review</b><br>Work closely with subject matter experts, intructional designers, and educational specialists to ensure content accuracy and relevance .Participate in peer reviews and provide constructive feedback to improve the quality of content generated by the team.<br>
            Coordinate with cross-functional teams to integrate feedback and ensure continuous improvement in question quality</p>
        <p><span class="step_no">4</span><b>Project Management </b><br>Manage and prioritize tasks to meet project deadlines and deliverables. Document processes, maintain organized records of prompts and generated content, and ensure date intergrity </p>
         </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Skills and Competencies:</h3>
		
                  <p> <span class="step_no">1</span>Excellent writing and communication skills</p>
        <p> <span class="step_no">2</span>Strong analytical and documentation skills</p>
        <p> <span class="step_no">3</span>Experience of using automated accounting applications and MS Office</p>
			

        <p> <span class="step_no">4</span>Strong presentation skills and interpersonal skills</p>

		 <p> <span class="step_no">5</span>Should be able to operate in unstructured environment with minimal support.</p>
 <p> <span class="step_no">6</span>Openness to travel if required</p>





      </div>
    </div>
  </div> -->
  <!-- feature box close -->

    <!-- feature box begin -->
    <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Key responsibilities:</h3>
        
			
<p><span class="step_no">1</span>Design, implement and Support financial management systems and procedures
</p>
<p><span class="step_no">2</span>Ensure fulfil1ment of requirements as laid under the financial management manual of SANKALP</p>
<p><span class="step_no">3</span>Prepare necessary financial reports including budget preparation, maintaining books of accounts, statement of expenditure etc.</p>
<p><span class="step_no">4</span>Support MSDE and other	stakeholders for fulfilling	audit requirements of SANKALP</p>
<p><span class="step_no">5</span>Support in bringing collaboration and partnership with various stakeholders.</p>
<p><span class="step_no">6</span>Develop periodic reports as per MSDE requirements</p>
<p><span class="step_no">7</span>Any other work as per MSDE requirement.</p>

    
          </div>
        </div>
      </div> -->
      <!-- feature box close -->

          <!-- feature box begin -->
    <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Period of Contract:</h3>
            <p>11 Months (extendable)</p>

           

    
          </div>
        </div>
      </div> -->
      <!-- feature box close -->

 <!-- feature box begin -->
    <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Method of recruitment:</h3>
            <p>Contract based through open market</p>

           

    
          </div>
        </div>
      </div> -->
      <!-- feature box close -->
    
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
       		<p>NIMI-Chennai </p>





      </div>
    </div>
  </div>
  <!-- feature box close -->

 <!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
         <h3>Division</h3> 
       		<p>t</p>





      </div>
    </div>
  </div> -->
  <!-- feature box close -->


  

<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;
 
    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>


